import React from "react";
import { motion } from "framer-motion";

const StatCard = ({ title, value, icon, color, trend }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="glass-card p-6 rounded-2xl border border-white/5 relative overflow-hidden group"
    >
      <div
        className={`absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity`}
      >
        {React.cloneElement(icon, { size: 80, color: color })}
      </div>

      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-4">
          <div
            className={`p-3 rounded-xl bg-${color}-500/10 text-${color}-500`}
            style={{ color: color, backgroundColor: `${color}20` }}
          >
            {icon}
          </div>
          <h3 className="text-gray-400 font-medium">{title}</h3>
        </div>

        <div className="flex items-end gap-3">
          <span className="text-3xl font-bold text-white">{value}</span>
          {trend && (
            <span
              className={`text-sm font-medium ${
                trend > 0 ? "text-green-400" : "text-red-400"
              } mb-1`}
            >
              {trend > 0 ? "+" : ""}
              {trend}%
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default StatCard;
